import { HTMLAttributes } from "react";
import { LabelContainer } from "../assets/style";

interface HookFormInputProps {
    title: any
    style?: any
    type?: string
    register: () => any
}

export default function HookFormInput(props: HookFormInputProps) {
    const { title, style, type, register } = props
    const inputStyle = {
        margin: "10px",
        marginLeft: "20px",
        borderRadius: "6px",
        height: "32px",
        // maxWidth: "250px",
        width: "50%",
        ...style,
    };

    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        minWidth: "200px",
        maxWidth: "600px",
    };
    // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setMethod(event.target.value);
    // };

    return (
        <div style={containerStyle}>
            <LabelContainer style={{ marginLeft: "28px" }}>
                {title + ": "}
            </LabelContainer>
            <input
                style={inputStyle}
                type={type}
                {...register()}
            />
        </div>
    )
}
